import { API_REQUEST, GET_PIER_MESSAGE, PIER_TUT_SET } from "../../actionTypes/actionsTypes";
import { AppAction } from "../../types";

// Get Pier Portal link text
export const getPierMessage = (): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: "/pier/status",
        next: GET_PIER_MESSAGE,
        method: 'GET',
        authorization: true,
    }
});

export const setPierTut = (pierTutSet: boolean): AppAction => ({
    type: PIER_TUT_SET,
    value: pierTutSet,
    payload: {}
})